import { EcommerceAPI } from "../Client";

export const updateQuickReplyApi = async (payload) =>
  EcommerceAPI.put("/app/quick/reply", payload);

export const postQuickReplyApi = async (payload) =>
  EcommerceAPI.post("/app/quick/reply", payload);

export const deleteQuickReplyApi = async (payload) =>
  EcommerceAPI.delete("/app/quick/reply", {
    params: { id: payload?.id },
  });

export const getQuickRepliesApi = async (payload) =>
  EcommerceAPI.get("/app/quick/replies", {
    params: { type: payload?.type },
  });

export const generateQuickReplyTranslationsDraftApi = async (payload) =>
  EcommerceAPI.post("/app/quick/replies/translations/draft", payload);

export const saveQuickReplyTranslationsApi = async (payload) =>
  EcommerceAPI.post("/app/quick/replies/translations", payload);

export const getQuickReplyTranslationsApi = async (payload) =>
  EcommerceAPI.get("/app/quick/replies/translations", {
    params: { language: payload?.language },
  });

export const getQuickReplyTranslationLanguagesApi = async () =>
  EcommerceAPI.get("/app/quick/replies/translations/languages");
